import CountUp from 'react-countup';
import { PCFooter } from '@commonPackage/components';
import { TECH_LIST_PC, COUNT_LIST, RouterConfigEnum } from '@portalCommon/constants';
import classnames from 'classnames/bind';
import { Back2Top, Contact, ContactBox, NavHeader, Consult } from '@/components';
import { PageTop } from './components/PageTop';
import { TechList } from './components/TechList';

import styles from './index.module.less';

const cx = classnames.bind(styles);

const CoreTechnology = () => {
  document.dispatchEvent(new Event('custom-render-trigger'));
  return (
    <>
      <NavHeader isStatic mode="white" />
      <div className={cx('core-technology-page')}>
        <PageTop
          title="核心技术"
          brief="用AI和3D数字化技术，探索互联网未来方向"
          bg="https://static.fuxi.netease.com/yaotai/portal/index/lez4p39n_603979.png?image_process=format,webp"
        />
        <div className={cx('count-content')}>
          {COUNT_LIST.map((item, idx) => (
            <div className={cx('count-item')} key={item.desc} style={{ backgroundImage: `url(${item.bg})` }}>
              <div style={{ position: 'relative' }}>
                <span className={cx('count-item-num')}>
                  {item.number < 10 ? item.number : <CountUp duration={0.5} start={item.start} end={item.number} />}
                </span>
                <span className={cx('count-item-unit', !idx && 'unique')}>{item.unit}</span>
              </div>
              <div className={cx('count-item-desc')}>{item.desc}</div>
            </div>
          ))}
        </div>
        <TechList list={TECH_LIST_PC} />
      </div>
      <Consult routerPath={RouterConfigEnum.CoreTechnology} />
      <Contact />
      <PCFooter isMain={import.meta.env.VITE_MAIN === 'true'} />
      <ContactBox />
      <Back2Top />
    </>
  );
};

export default CoreTechnology;
